import ReactModal from 'react-modal'

import IconClose from '@/assets/icons/ic_logic-g-app_close.svg'
import { cn } from '@/utils/tw-helpers'

ReactModal.setAppElement('#__next')

export interface ModalProps extends ReactModal.Props {
  size?: 'sm' | 'md' | 'lg'
  customStyles?: ReactModal.Styles
  showCloseButton?: boolean
  closeButtonClassName?: string
}

const contentWidth = {
  sm: '330px',
  md: '330px',
  lg: '330px',
}

export const Modal = ({
  size,
  customStyles,
  children,
  showCloseButton = true,
  closeButtonClassName = '',
  ...rest
}: ModalProps): JSX.Element => {
  return (
    <ReactModal
      style={{
        overlay: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#abbfc383',
          zIndex: 40,
          ...customStyles?.overlay,
        },
        content: {
          position: 'relative',
          inset: 'unset',
          width: contentWidth[size || 'md'],
          margin: '0 auto',
          border: 0,
          borderRadius: '8px',
          ...customStyles?.content,
        },
      }}
      {...rest}
    >
      {children}
      {showCloseButton ? (
        <button
          aria-label="Close modal"
          className={cn('absolute right-[11px] top-[7px] text-[#C1C1C1]', closeButtonClassName)}
          onClick={rest.onRequestClose}
        >
          <IconClose width={40} />
        </button>
      ) : null}
    </ReactModal>
  )
}
